module.exports = __webpack_public_path__ + "static/media/digital-ocean.49c4411c.svg";